import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";

export class DefaultTranslationHandler implements MissingTranslationHandler {

  lastKey: string = "";
  logMissingKeys: boolean = true;

  handle(params: MissingTranslationHandlerParams) {
    let defaultLang: string = params.translateService.getDefaultLang();
    let currentLang: string = params.translateService.currentLang;
    if(this.logMissingKeys) {
      console.error('--- Missing translation ---');
      console.error('DefaultLang: ' + defaultLang);
      console.error('CurrentLang: ' + currentLang);
      console.error('Key: ' + params.key);
      console.error('Params: ' + params.interpolateParams);
      console.error('--------------------------');
    }
    if(currentLang != defaultLang && params.key != this.lastKey) {
      this.lastKey = params.key;
      params.translateService.use(defaultLang);
      let defaultTranslation = params.translateService.get(params.key, params.interpolateParams);
      params.translateService.use(currentLang);
      return defaultTranslation;
    } else {
      return undefined;
    }

  }

}
